<template>
  <div>
    <!-- 标题 -->
    <h2>文件信息管理</h2>
    <!-- 筛选条件 -->
    <el-row :gutter="20" style="margin-bottom: 20px;">
      <el-col :span="8">
        <el-select v-model="filter.type" placeholder="选择文件类型" clearable>
          <el-option value="" label="全部" />
          <el-option value="image" label="图片" />
          <el-option value="video" label="视频" />
          <el-option value="faq" label="常见问题" />
        </el-select>
      </el-col>
      <el-col :span="8">
        <el-input v-model="filter.name" placeholder="请输入文件名" clearable />
      </el-col>
      <el-col :span="8">
        <el-button type="primary" @click="getFiles">查询</el-button>
        <el-button @click="resetFilters">重置</el-button>
      </el-col>
    </el-row>
    <!-- 添加按钮 -->
    <el-row style="margin-bottom: 20px;">
      <el-col :span="24">
        <el-button type="primary" icon="el-icon-plus" @click="showUploadDialog">上传文件</el-button>
      </el-col>
    </el-row>
 <!-- 编辑文件名弹框 -->
    <el-dialog title="编辑文件名" v-model="editDialogVisible">
      <el-form :model="editForm" label-width="100px">
        <el-form-item label="文件名">
          <el-input v-model="editForm.name" placeholder="请输入文件名" size="small" />
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitEdit">确认</el-button>
      </div>
    </el-dialog>
    <!-- 文件信息表格 -->
    <el-table :data="files" border style="width: 100%">
      <!-- 修改判断条件，确保只有在点击查询后才显示 FAQ 表格 -->
      <template v-if="filter.type === 'faq' && files.length > 0 && files[0].type === 'faq'">
        <!-- FAQ专用列 -->
        <el-table-column prop="question" label="问题" min-width="200">
          <template v-slot="{ row }">
            <div class="faq-question-cell">{{ row.question }}</div>
          </template>
        </el-table-column>
        
        <el-table-column prop="answer" label="解答" min-width="300">
          <template v-slot="{ row }">
            <div v-if="row.answer" class="faq-answer-cell">{{ row.answer }}</div>
            <el-button 
              v-else 
              type="primary" 
              size="small" 
              @click="showAnswerDialog(row)"
            >添加解答</el-button>
          </template>
        </el-table-column>
        
        <el-table-column prop="isShow" label="展示状态" width="120">
          <template v-slot="{ row }">
            <el-tag :type="row.isShow ? 'success' : 'info'">
              {{ row.isShow ? '已展示' : '未展示' }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="150">
          <template v-slot="{ row }">
            <el-button
                type="text"
                size="small"
                @click="toggleFaqShow(row)"
            >
              {{ row.isShow ? '取消展示' : '展示' }}
            </el-button>
            <el-button
                type="text"
                size="small"
                @click="deleteFile(row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </template>
      
      <template v-else>
        <!-- 原有的图片和视频表格列 -->
        <!-- 文件展示列 -->
        <el-table-column label="文件展示" width="300">
          <template v-slot="{ row }">
            <div v-if="row.type === 'image'" class="file-display">
              <img :src="row.url" alt="图片预览" class="file-image" />
            </div>
            <div v-else-if="row.type === 'video'" class="file-display">
              <video :src="row.url || row.url" alt="视频封面" class="file-image" />
            </div>
            <div v-else-if="row.type === 'faq'" class="faq-display">
              <div class="faq-preview">
                <div class="faq-question">问：{{ row.question }}</div>
                <div class="faq-answer">答：{{ row.answer }}</div>
              </div>
            </div>
          </template>
        </el-table-column>

        <!-- 文件名称 -->
        <el-table-column prop="name" label="文件名称" width="200">
          <template v-slot="{ row }">
            <el-input v-model="row.name" size="small" disabled />
          </template>
        </el-table-column>


        <!-- 操作列 -->
        <el-table-column label="操作" width="120">
          <template v-slot="{ row }">
            <div style="display: flex; align-items: center; gap: 0;">
            <el-button type="text" size="small" @click="editFile(row)">编辑</el-button>
            <el-button type="text" size="small" @click="deleteFile(row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </template>
    </el-table>

    <!-- 分页组件 -->
    <el-pagination
        background
        layout="prev, pager, next, sizes, total"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="total"
        @current-change="handlePageChange"
        @size-change="handlePageSizeChange"
    />


    <!-- 上传文件弹框 -->
    <el-dialog title="上传文件" v-model="uploadDialogVisible">
      <el-form :model="uploadForm" label-width="100px">
        <el-form-item label="文件类型">
          <el-radio-group v-model="uploadForm.fileType">
            <el-radio label="image">图片</el-radio>
            <el-radio label="video">视频</el-radio>
            <el-radio label="faq">常见问题</el-radio>
          </el-radio-group>
        </el-form-item>

        <template v-if="uploadForm.fileType === 'faq'">
          <el-form-item label="问题">
            <el-input v-model="uploadForm.question" type="textarea" rows="2" placeholder="请输入问题" />
          </el-form-item>
          <el-form-item label="答案">
            <el-input v-model="uploadForm.answer" type="textarea" rows="4" placeholder="请输入答案" />
          </el-form-item>
        </template>

        <template v-else>
          <el-form-item label="选择文件">
            <el-upload
              ref="fileUploader"
              :on-change="handleFileChange"
              :before-upload="beforeUpload"
              :file-list="fileList"
              auto-upload="false"
            >
              <el-button type="primary">选择文件</el-button>
            </el-upload>
            <!-- 文件名展示 -->
            <div v-if="selectedFileName" style="margin-top: 20px;">
              <span>已选择文件：</span>
              <b>{{ selectedFileName }}</b>
            </div>
          </el-form-item>

          <el-form-item label="自定义文件名">
            <el-input v-model="uploadForm.customFileName" placeholder="请输入文件名" size="small" />
          </el-form-item>
        </template>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="uploadDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitUpload">确认</el-button>
      </div>
    </el-dialog>

    <!-- 添加解答对话框 -->
    <el-dialog 
      title="添加解答" 
      v-model="answerDialogVisible" 
      width="50%"
    >
      <el-form :model="answerForm" label-width="80px">
        <el-form-item label="问题">
          <el-input 
            v-model="answerForm.question" 
            type="textarea" 
            :rows="2" 
            disabled
          />
        </el-form-item>
        <el-form-item label="解答">
          <el-input 
            v-model="answerForm.answer" 
            type="textarea" 
            :rows="4" 
            placeholder="请输入解答内容"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="answerDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitAnswer">确认</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import axios from "@/axios";
import { ElMessage, ElMessageBox } from 'element-plus'; // 添加 ElMessageBox 的导入


export default {
  props: {
    userid: {
      type: Number,
      required: true,
    },
    organizationID: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      editDialogVisible :false,
      editForm:{name:'',id:'',type:''},
      files: [], // 文件列表
      uploadDialogVisible: false, // 上传弹框显示控制
      uploadForm: {
        fileType: "image", // 默认上传类型为图片
        customFileName: "", // 自定义文件名
        question: "", // 新增
        answer: "", // 新增
      },
       // 筛选条件
      filter: {
        type: "", // 文件类型 (image, video, 或空)
        name: "", // 文件名称 (模糊搜索)
      },

      // 分页相关
      currentPage: 1, // 当前页码
      pageSize: 5, // 每页显示数量
      total:0,
      fileList: [], // 文件列表
      selectedFileName: "", // 用于显示的文件名
      orgId: this.organizationID, // 组织ID
      userId: this.userid, // 用户ID
      imageUploadUrl: "http://localhost:999/images/upload1",
      videoUploadUrl: "http://localhost:999/videos/upload1",
      faqUploadUrl: "http://localhost:999/faq/upload", // ��增 FAQ 上传接口
      testFaqData: [

      ],
      answerDialogVisible: false,
      answerForm: {
        id: null,
        question: '',
        answer: ''
      }
    };
  },

  methods: {
    // 打开上传文件弹框
    showUploadDialog() {
      this.uploadDialogVisible = true;
    },

    // 校验上传文件
    beforeUpload(file) {
      const isImage = this.uploadForm.fileType === "image" && file.type.startsWith("image/");
      const isVideo = this.uploadForm.fileType === "video" && file.type.startsWith("video/");
      const isValid = isImage || isVideo;

      if (!isValid) {
        ElMessage.error("文件类型不符合要求");
        return false;
      }

      const maxSize = this.uploadForm.fileType === "image" ? 10 : 500; // 图片最大10MB，视频最大500MB
      const isLtSize = file.size / 1024 / 1024 < maxSize;
      if (!isLtSize) {
        ElMessage.error(`文件大小不能超过 ${maxSize}MB`);
        return false;
      }

      return false;
    },

    // 处理文件变化
    handleFileChange(file) {
      this.fileList = [file]; // 获取上传文件
      this.selectedFileName = file.name; // 记录选的文件名
    },

    // 提交上传
    submitUpload() {
      if (this.uploadForm.fileType === 'faq') {
        // 模拟添加新的 FAQ
        const newFaq = {
          question: this.uploadForm.question,
          answer: this.uploadForm.answer,
          isShow:false,
          organizationId:this.organizationID,
          userId: this.userid

        };
        axios.post(this.faqUploadUrl, newFaq).then(
            (res) => {

              if(res.data.success) {
                this.uploadDialogVisible = false;
                this.uploadForm.question = "";
                this.uploadForm.answer = "";
                this.getFiles();
                ElMessage.success(res.data.data);
              }
              else {
                ElMessage.error(res.data.errorMsg);
              }
            }
        ).catch(
            (error) => {
              ElMessage.error("文件上传失败");
              console.error(error);
            }
        )
        // this.testFaqData.push(newFaq);



        return;
      }

      if (this.fileList.length === 0) {
        ElMessage.error("请选择文件后再提交");
        return;
      }

      const file = this.fileList[0];
      const customName = this.uploadForm.customFileName;
      const fileName = customName || file.name;

      // 确保文件名包含正确的后缀
      const extension = file.name.split(".").pop();
      const finalFileName = customName ? `${customName}.${extension}` : fileName;

      const formData = new FormData();
      formData.append("file", file.raw);
      formData.append("organizationId", this.orgId);
      formData.append("userId", this.userId);
      formData.append("fileName", finalFileName);

      const uploadUrl = this.uploadForm.fileType === "image" ? this.imageUploadUrl : this.videoUploadUrl;

      axios.post(uploadUrl, formData)
        .then((response) => {
          if(response.data.success ) {
            this.getFiles()
            ElMessage.success(response.data.data);
            this.uploadDialogVisible = false;
            this.fileList = [];
            this.selectedFileName = ''
            this.uploadForm.customFileName = ""; // 重置文件名输入
          }
          else {
            ElMessage.error(response.data.errorMsg);
          }

        })
        .catch((error) => {
          ElMessage.error("文件上传失败");
          console.error(error);
        });
    },
editFile(row){

      this.editDialogVisible = true;

      this.editForm.name = row.name
  this.editForm.id=row.id
  this.editForm.type=row.type

},
      // 提交编辑文件名
  submitEdit() {
      let url
if(this.editForm.type === 'image'){
  url = '/images/update'
}else if(this.editForm.type === 'video'){
  url = '/videos/update'}

else { ElMessage.error('未知错误');
return}



      axios
        .get(url, {params:{ newName: this.editForm.name, id: this.editForm.id,
          userId: this.userId,organizationId: this.orgId}})
        .then((res) => {
          if(res.data.success) {
            ElMessage.success(res.data.data);
            this.getFiles()
            this.editDialogVisible = false;  // 关闭编辑弹框}
          }else {
            ElMessage.error(res.data.errorMsg);
          }
        })
        .catch((error) => {
          this.$message.error("更新文件名失败");
          console.error(error);
        });

  },
    // 删除文件
    deleteFile(file) {
      if (file.type === 'faq') {
        ElMessageBox.confirm('确定要删除这条FAQ吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          axios.delete(`/faq/delete/${file.id}`, {
            params: {
              organizationId: this.organizationID
            }
          })
              .then(response => {
                if (response.data.success) {
                  ElMessage.success('FAQ删除成功');
                  this.getFiles(); // 重新加载数据
                } else {
                  ElMessage.error(response.data.errorMsg || 'FAQ删除失败');
                }
              })
              .catch(error => {
                console.error('FAQ删除失败:', error);
                ElMessage.error('FAQ删除失败');
              });
        }).catch(() => {
          ElMessage.info('已取消删除');
        });
        return;
      }

      console.log(file.type)

      if(file.type === 'image') {
        axios
            .delete(`/images/delete1/${file.id}`)
            .then((res) => {
if(res.data.success) {
  this.getFiles()
  ElMessage.success("文件删除成功");

}else {
   ElMessage.error(res.data.errorMsg);
}
            })
            .catch(() => {
              ElMessage.error("文件删除失败");
            });
      }
      else {
        axios
            .delete(`/videos/delete1/${file.id}`)
            .then((res) => {
              if(res.data.success) {
                this.getFiles()
                ElMessage.success("文件删除成功");
              }
              else { ElMessage.error(res.data.errorMsg);}
            })
            .catch(() => {
              ElMessage.error("文件删除失败");
            });
      }
    },

    // 分页变更处理

    handlePageChange(page) {
      this.currentPage = page;
      this.getFiles(); // 页码变化重新获取数据
    },
    // 每页数量变化
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1; // 重置为第一页
      this.getFiles();
    },
       // 获取文件列表
    getFiles() {
      const params = {
        videoName: this.filter.name,
     organizationId: this.orgId,
        userId: this.userId,
        page: this.currentPage , // 后端分页从 0 开始
        size: this.pageSize,
      };
       let  urls
      if(this.filter.type === 'image'){
          urls = '/images/search1'
      }
      else if(this.filter.type === 'video'){
          urls = '/videos/search1'
      }
      else if(this.filter.type === 'faq'){
        // 如果是 FAQ 类型，使用测试数据
        // let filteredData = [...this.testFaqData];
        //
        // // 如果有搜索关键词，进行筛选
        // if (this.filter.name) {
        //   filteredData = filteredData.filter(item =>
        //     item.question.includes(this.filter.name) ||
        //     item.answer.includes(this.filter.name)
        //   );
        // }
        //
        // // 计算分页
        // const start = (this.currentPage - 1) * this.pageSize;
        // const end = start + this.pageSize;
        //
        // this.total = filteredData.length;
        // this.files = filteredData.slice(start, end);
        //
        // return;

        urls = 'faq/search'

        axios.get(urls, {params} ).then((response) => {
          console.log(response.data.data)

          this.total=response.data.total;
          this.files = response.data.data.map(file => {
             let  fileType='faq';
            return {
              ...file,
              type: fileType, // 加上 type 字段
            };
          });}).catch((error) => {
          this.$message.error("获取文件列表失败");
          console.error(error);
        });

        return
      }
      else {
          // urls = '/images/all'
          urls = '/images/search1'
      }
      axios.get(urls, {params} ).then((response) => {
          console.log(response.data.data)

        this.total=response.data.total;
       this.files = response.data.data.map(file => {
         let fileType
         if( file.name===undefined){
           fileType='video';
         }
         else  fileType ='image'
  const fileName = fileType === 'video' ? file.videoName : file.name;
  const src = fileType === 'video' ? file.videoPath : file.src;
  return {
    ...file,
    name: fileName, // 统一文件名字段为 name
    type: fileType, // 加上 type 字段
    url:src
  };
});}).catch((error) => {
          this.$message.error("获取文件列表失败");
          console.error(error);
        });


    },

    // 重置筛选条件
    resetFilters() {
      this.filter.type = "";
      this.filter.name = "";
      this.getFiles();
    },

    toggleFaqShow(row) {
      const action = row.isShow ? '取消展示' : '展示';
      ElMessageBox.confirm(`确定要${action}这条FAQ吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 修改请求方式和参数
        axios.put(`/faq/toggle/${row.id}`, null, {
          params: {
            organizationId: this.organizationID
          }
        })
            .then(response => {
              if (response.data.success) {
                row.isShow = !row.isShow; // 更新本地状态
                ElMessage.success('FAQ状态更新成功');
                this.getFiles(); // 重新加载数据以确保状态同步
              } else {
                ElMessage.error(response.data.errorMsg || '更新FAQ状态失败');
              }
            })
            .catch(error => {
              console.error('更新FAQ状态失败:', error);
              ElMessage.error('更新FAQ状态失败');
            });
      }).catch(() => {
        ElMessage.error('已取消操作');
      });
    },

    // 显示解答对话框
    showAnswerDialog(row) {
      this.answerForm.id = row.id;
      this.answerForm.question = row.question;
      this.answerForm.answer = '';
      this.answerDialogVisible = true;
    },

    // 提交解答
    submitAnswer() {
      if (!this.answerForm.answer.trim()) {
        ElMessage.warning('请输入解答内容');
        return;
      }

      axios.put(`/faq/update/${this.answerForm.id}`, {
        answer: this.answerForm.answer
      }, {
        params: {
          organizationId: this.orgId
        }
      })
        .then(response => {
          if (response.data.success) {
            ElMessage.success('解答添加成功');
            this.answerDialogVisible = false;
            this.getFiles(); // 重新加载数据
          } else {
            ElMessage.error(response.data.errorMsg || '解答添加失败');
          }
        })
        .catch(error => {
          console.error('解答添加失败:', error);
          ElMessage.error('解答添加失败');
        });
    },
  },

  created() {

    this.getFiles()
       console.log('zhb'+this.files)
    console.log(this.userid)
    console.log(this.organizationID)
  },

};
</script>

<style scoped>
h2 {
  margin-bottom: 20px;
}

.file-display {
  display: flex;
  align-items: center;
  justify-content: center;
}

.file-image {
  max-width: 100px;
  max-height: 100px;
  object-fit: contain;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 5px;
}

.el-input {
  width: 100%;
}

/* 添加 FAQ 相关样式 */
.faq-display {
  padding: 10px;
  width: 100%;
}

.faq-preview {
  text-align: left;
  border: 1px solid #eee;
  padding: 10px;
  border-radius: 4px;
}

.faq-question {
  font-weight: bold;
  margin-bottom: 5px;
  color: #333;
}

.faq-answer {
  color: #666;
}

.faq-question-cell {
  white-space: pre-wrap;
  word-break: break-all;
  line-height: 1.5;
}

.faq-answer-cell {
  white-space: pre-wrap;
  word-break: break-all;
  line-height: 1.5;
  color: #666;
}

.dialog-footer {
  padding: 20px 0;
  text-align: right;
}
</style>
